import { queryKeys } from '@/react-query/constants';
import { createFeatureApi, createQueryKeys } from '@/shared/api';

/**
 * The packages feature roots on queryKeys.advertisingPackages — the same family that
 * existing `invalidateQueries([queryKeys.advertisingPackages])` calls match by prefix.
 * `packagesForSpaceKeys` is a DISTINCT cache root for the space-coupled read.
 * Both are INTERNAL — consumers use the exported hooks, never these objects.
 */
export const packagesApi = createFeatureApi(queryKeys.advertisingPackages);
export const packagesForSpaceKeys = createQueryKeys(queryKeys.advertisingPackagesForSpace);
